// 3rd party
import React from "react"

function Info() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 600 222"
      height="15"
      fill="#fff"
      style={{"display": "block", "marginTop": "6px"}}
    >
      <g>
        <path d="M43.5,202.3h19.2v20.1H0.6v-20.1h18.7V20.5H0.6V0.4h62.2v20.1H43.5V202.3z" />
        <path
          d="M280.1,20.5h-18.7v201.9h-29L148.7,49.6v152.8h19.2v20.1h-62.2v-20.1h18.7V20.5h-18.7V0.4h45.6l85.9,176.5
		V20.5h-19.2V0.4h62.2V20.5z"
        />
        <path
          d="M403.3,117.7h-41.7v84.7h19.2v20.1h-62.2v-20.1h18.7V20.5h-18.7V0.4h138.9v54.8h-20.1V20.5h-75.8v77h41.7v-21
		h20.1v62.2h-20.1V117.7z"
        />
        <path
          d="M565,0.4c24,0,34.3,13.3,34.3,39.4v142.4c0,28.1-8,40.3-32.9,40.3h-56.9c-27.2,0-35.2-14.2-35.2-35.8V39.8
		c0-24.6,5.9-39.4,32.9-39.4H565z M498.1,202.3h77.6V20.5h-77.6V202.3z"
        />
      </g>
    </svg>
  )
}

export default Info
